import { Box, Button, Card, CardContent, Chip, CircularProgress, Typography, Grid } from '@mui/material'
import { FotosProducto } from '../types/producto'

interface PropsDetalle {
  fotos: FotosProducto[]
  loading: boolean
  loadingButtons: Record<string, boolean>
  sincronizarFotos: (limit: number, idFoto: number, idProducto: number) => Promise<void>
  eliminarCaptions: (idFoto: number, idProducto: number) => void
}

const ESTADOS = [
  { label: 'Procesada', key: 'caption', color: 'success' },
  { label: 'Pendiente', key: 'pendiente', color: 'warning' },
  { label: 'Error', key: 'error', color: 'error' }
]
/* eslint-disable react/prop-types */
const DetalleFotos: React.FC<PropsDetalle> = ({
  fotos,
  loading,
  loadingButtons,
  sincronizarFotos,
  eliminarCaptions
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* spacing reducido para que las cards estén más juntas */}
      <Grid container spacing={1}>
        {fotos.map((img: FotosProducto) => {
          const estado = ESTADOS.find((e: any) => e.key === img.estado)?.label
          const color = ESTADOS.find((e: any) => e.key === img.estado)?.color

          return (
            <Grid item xs={6} sm={6} md={3} key={img.idFotoProducto}>
              <Card
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  '&:hover': { boxShadow: 3 },
                  height: '100%'
                }}
              >
                {/* Thumbnail más compacto */}
                <Box
                  sx={{
                    width: '100%',
                    height: 140, // menos alto
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'grey.100',
                    p: 1
                  }}
                >
                  <img
                    src={img.urlThumb}
                    alt="Foto producto"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      borderRadius: 4
                    }}
                  />
                </Box>

                {/* Datos abajo */}
                <CardContent sx={{ py: 0.8, px: 1.25, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flexGrow: 1 }}>
                    <Chip
                      label={estado}
                      color={color as 'success' | 'warning' | 'error'}
                      size="small"
                      sx={{ alignSelf: 'flex-start' }}
                    />
                    {['caption', 'error'].includes(img.estado) && (img.caption || '').trim().length > 0 ? (
                      <Box>
                        <Typography
                          variant="body2"
                          component="div"
                          sx={{
                            fontSize: '0.82rem',
                            lineHeight: 1.15,
                            overflow: 'hidden',
                            color: 'text.secondary'
                          }}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: (img.caption || '').replace(/\n/g, '<br>')
                            }}
                          />
                        </Typography>
                      </Box>
                    ) : img.estado === 'pendiente' ? (
                      <Typography variant="body2" sx={{ fontSize: '0.82rem', color: 'text.secondary' }}>
                        Pendiente de procesar
                      </Typography>
                    ) : null}

                    {/* Botones apilados en columna (no row). gap pequeño y ocupando todo el ancho */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 0.5 }}>
                      {img.caption ? (
                        <Button
                          onClick={() => eliminarCaptions(img.idFotoProducto, 0)}
                          variant="contained"
                          color="error"
                          size="small"
                          fullWidth
                          disabled={loadingButtons[`eliminar-foto-${img.idFotoProducto}`] || loading}
                          sx={{ py: 0.5, fontSize: '0.7rem' }}
                        >
                          {loadingButtons[`eliminar-foto-${img.idFotoProducto}`] ? (
                            <CircularProgress size={18} color="inherit" />
                          ) : (
                            'Eliminar caption'
                          )}
                        </Button>
                      ) : (
                        <Button
                          onClick={() => sincronizarFotos(1, img.idFotoProducto, 0)}
                          variant="contained"
                          color="success"
                          size="small"
                          fullWidth
                          disabled={loadingButtons[`caption-foto-${img.idFotoProducto}`] || loading}
                          sx={{ py: 0.5, fontSize: '0.7rem' }}
                        >
                          {loadingButtons[`caption-foto-${img.idFotoProducto}`] ? (
                            <CircularProgress size={18} color="inherit" />
                          ) : (
                            'Generar caption'
                          )}
                        </Button>
                      )}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )
        })}
      </Grid>
    </Box>
  )
}

export default DetalleFotos
